import { Link } from "react-router-dom";
import { mangaCategories } from "@/mocks/mangaCategories";

const quickLinks = [
  { to: "/", label: "网站首页" },
  { to: "/category", label: "漫画分类" },
  { to: "/category/completed", label: "完结大全" },
  { to: "/category/ongoing", label: "连载追更" },
  { to: "/about", label: "关于我们" },
];

export default function MangaFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2" title="土豪漫画网首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-fire-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">土豪漫画网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注《家庭教师》等热血少年漫画的免费在线阅读平台,高清画质、每日更新,为漫画爱好者提供沉浸式的追更体验。
            </p>
          </div>

          <nav aria-label="快捷导航">
            <h3 className="mb-4 text-sm font-bold text-foreground-950">快速导航</h3>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h3 className="mb-4 text-sm font-bold text-foreground-950">热门分类</h3>
            <ul className="flex flex-wrap gap-2">
              {mangaCategories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="inline-block whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-950">联系我们</h3>
            <ul className="flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" aria-hidden="true" />
                <span>service@tuhaomanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-qq-line text-primary-600" aria-hidden="true" />
                <span>读者群 88881234</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" aria-hidden="true" />
                <span>客服时间:每日 9:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-200 bg-secondary-200/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 土豪漫画网 版权所有</p>
          <p>本站内容仅供学习交流,请于下载后 24 小时内删除</p>
        </div>
      </div>
    </footer>
  );
}